import { useCallback } from 'react';
import { useConfig } from '../../../../context';
import { mapRoutePath } from './mapRoutePath';
export function useRoutePath() {
    var _a;
    const enabled = (_a = useConfig().global.alternativeRouting) !== null && _a !== void 0 ? _a : false;
    return useCallback(((path) => mapRoutePath(path, enabled)), [enabled]);
}
